import React from 'react';
import { useTranslation } from 'react-i18next';
import config from '../../Configurations/KodakConfigUI.json'
import './footer.css';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import FetchResources from '../../Configurations/LangConfig';
import './footer.scss'
import { useParams, useNavigate } from 'react-router-dom';
import {GetConvertedLangsymbols,GetLanguage} from '../../Configurations/LangConfig'


const footer_configs = config.footerConfig.footer_Links;

const Footer = (props) => {
  const determineLanguage = (langCode) => {
    return GetLanguage(langCode);
  }

  const determineLangCode = (language) => {
    return GetConvertedLangsymbols(language)
  }
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const changeLanguage = (lng) => {
    navigate("/" + determineLangCode(lng));
  };
  const {langCode} = useParams();
  console.log('Language Code: ' + langCode)
  const [language, setLanguage] = React.useState(determineLanguage(langCode))

  React.useEffect(() => {
    i18n.changeLanguage(language);
  }, [language])

  React.useEffect(() => {
    setLanguage(determineLanguage(langCode));
  }, [langCode])

  return (
    <div className="footer">
      {
        footer_configs.map((x, index) => {
          return(
            <div className='footer-section'>
              <h3>
                <a href={x.link} title={x.link_name} target='_blank'>{t(x.link_name)}</a>
              </h3>
            </div>
          )
        })
      }

      <div className="footer-section">
        <DropDownList
        data={Object.keys(FetchResources())}
        onChange={e => changeLanguage(e.target.value)}
        defaultValue={language}
        />
      </div>     
      <div className='footer-copyright'>
        <p>{t('copyright')}</p>
      </div>

    </div>
  );
};

export default Footer;
